<script>
import GiftItem from "@/components/gift/GiftItem.vue";
import { Toast } from "vant";
import {sendAppMessage} from "@/util/sendAppMessage";

export default {
  name: "GiftPanel",
  components: { GiftItem },
  props: ["course_id"],
  data() {
    return {
      loading: false,
      show: false,
      confirmPanel: false,
      giftList: [],
      giftPayTypeList: [],
      selectGift: null,
      currentSwipeIndex: 0,
      overflow: "",
      mp_open_id: "",
      qrcodeUrl: "",
      showQrcode: false,
      swipeHeight: 0,
      showConfirmDialog: false,
      otherData: {},
      userInfo: this.$store.getters.getUserInfo || null
    };
  },
  watch: {
    show() {
      if(!this.show) return;
      this.$nextTick(() => {
        this.calcHeight();
      })
    }
  },
  mounted() {
    this.getData();
  },
  methods: {
    calcHeight() {
      let myPopup = document.querySelector(".my-popup");
      let mySwipe = document.querySelector(".my-swipe");
      let myHeader = document.querySelector(".header");
      this.swipeHeight = myPopup.getBoundingClientRect().height - myHeader.getBoundingClientRect().height;
    },

    getData() {
      this.loading = true;
      this.$axios.get("/gift/getGiftList").then(res => {
        this.giftList = res.data;
        this.otherData = res.other_data;
      }).finally(_ => {
        this.loading = false;
      })
    },
    open() {
      this.show = true;
      this.getData();
    },
    close() {
      this.show = false;
      // this.changeToGift();
    },
    onSelect(item) {
      this.selectGift = item;
      this.showConfirmDialog = true;
      // this.changeToConfirm();
    },
    onCancelGift() {
      if (this.currentSwipeIndex === 0) return;
      this.changeToGift();
    },
    changeToConfirm() {
      this.currentSwipeIndex = 1;
      this.actionContentHeight = "auto";
      this.$refs.mySwipe.swipeTo(this.currentSwipeIndex, { immediate: true });
    },
    changeToGift() {
      this.currentSwipeIndex = 0;
      this.actionContentHeight = "16rem";
      this.$refs.mySwipe.swipeTo(this.currentSwipeIndex, { immediate: true });
    },
    async getUserInfo() {
      if(this.userInfo) {
        return this.userInfo;
      }
      let userRes = await this.$axios.$get("/user/getUserInfo");
      if (userRes.code == 10001) {
        this.$store.commit("setUserInfo", userRes.data);
        this.userInfo = userRes.data;
        return this.userInfo;
      }
    },
    onButtonClick(type) {
      // let channel = type.channel;
      this.$axios.post("/gift/makeGiftOrder", { gift_id: this.selectGift.id, course_id: this.course_id }).then(res => {
        if(res.code === 10001) {
          let status = res.data.gift_order_status;
          let order_id = res.data.gift_order_id;
          if (status === 2) {
            Toast.success({ message: "礼物已送出", position: "top", icon: "gift-o" });
            this.close();
          }
        }
        if(res.code === 10002 && res.tip === "#2021") {
          console.log("余额不足");
          this.$dialog.confirm({title: "余额不足,是否前往充值？"}).then(async () => {
            sendAppMessage({jump_type: 998, jump_url: ""});
            this.close();
          }).catch(() => {
            this.close();
          })
        }
        // this.pay({ channel, status, order_id });
      }).catch(err => {
        console.log(err);
      });
    },
    qrcodeOk() {
      this.showQrcode = false;
      this.close();
    },
    onSendGift() {

    },
    async goPush() {
      sendAppMessage({jump_type: 998, jump_url: ""});
      this.close();
    }
  }
};
</script>

<template>
  <div class="gift-panel">
    <van-popup v-model="show" class="my-popup" position="bottom" @closed="close">
      <div class="header flex justify-between items-center p-2 border-b sticky top-0 left-0 right-0 bg-white"
           style="z-index: 999">
        <van-icon :color="currentSwipeIndex === 0 ? 'transparent' : '#000'" name="arrow-left" size="20"
                  @click="onCancelGift" />
        <p>礼物打赏</p>
        <van-icon name="cross" size="20" @click="close" />
      </div>
      <van-swipe ref="mySwipe" :height="swipeHeight" :loop="false" :show-indicators="false" :touchable="false" class="my-swipe">
        <van-swipe-item>
          <van-loading v-if="loading" class="w-full h-full flex justify-center items-center" type="spinner"></van-loading>
          <div v-else class="relative h-full pb-16">
            <div class="gift-list grid grid-cols-4 gap-3 px-5 pt-2 w-full h-full overflow-auto">
              <GiftItem v-for="(item, index) in giftList" :key="index" :item="item" :unit="otherData.icon.name" @click="onSelect"></GiftItem>
            </div>
            <div v-if="otherData && otherData.icon" class="balance px-5 text-base border-t py-4 flex justify-between items-center absolute bottom-0 w-full bg-white">
              <div class="flex items-center">
                <img :src="otherData.icon.img_url" alt="" class="w-5 h-5 mr-1">
                <p class="text-gray-500">{{ otherData.icon.name }}：<span class="text-black font-bold">{{ otherData.icon.amount }}</span> 个</p>
              </div>
              <p @click="goPush">
                <span>充值</span>
                <van-icon name="arrow"></van-icon>
              </p>
            </div>
          </div>
        </van-swipe-item>
<!--        <van-swipe-item>-->
<!--          <div v-if="selectGift" class="p-5">-->
<!--            <div class="left text-center flex flex-col justify-center items-center">-->
<!--              <img :src="selectGift.img_url" alt="" class="w-16 mb-2">-->
<!--              <p>{{ selectGift.name }}</p>-->
<!--              <p class="text-red-600 font-bold text-sm">¥{{ selectGift.price }}</p>-->
<!--            </div>-->
<!--            &lt;!&ndash;            <div v-if="giftPayTypeList && giftPayTypeList.length > 0" class="btns mt-2">&ndash;&gt;-->
<!--            &lt;!&ndash;              <van-button v-for="type in giftPayTypeList" :key="type.channel" :icon="type.img" block round&ndash;&gt;-->
<!--            &lt;!&ndash;                          @click="onButtonClick(type)">{{ type.name }}&ndash;&gt;-->
<!--            &lt;!&ndash;              </van-button>&ndash;&gt;-->
<!--            &lt;!&ndash;            </div>&ndash;&gt;-->
<!--            <div v-if="giftPayTypeList && giftPayTypeList.length > 0" class="flex mt-5 border-t pt-5">-->
<!--              <div v-for="type in giftPayTypeList" :key="type.channel"-->
<!--                   class="btn flex-1 flex flex-col justify-center items-center px-2" @click="onButtonClick(type)">-->
<!--                <img :src="type.img" alt="" class="w-10 mb-3">-->
<!--                <p class="font-bold">{{ type.name }}</p>-->
<!--              </div>-->
<!--            </div>-->
<!--          </div>-->
<!--        </van-swipe-item>-->
      </van-swipe>
    </van-popup>

    <van-dialog v-if="showConfirmDialog" v-model="showConfirmDialog" show-cancel-button @confirm="onButtonClick">
      <div class="flex flex-col items-center py-8">
        <img :src="selectGift.img_url" class="w-12 h-12 mb-2"/>
        <p class="text-gray-500 mb-2">送出 <span class="font-bold">{{selectGift.name}} × 1</span></p>
        <p class="text-gray-500">
          消耗
          <span class="font-bold">{{ selectGift.coin_price }}个</span>
          {{ otherData.icon.name }}
        </p>
      </div>
    </van-dialog>
  </div>
</template>

<style scoped>

.van-popup {
  height: 50%;
}

.btns .van-button {
  width: 100%;
}

.btns .van-button:not(:last-child) {
  margin-bottom: 0.5rem;
}

.qr-img-container img {
  width: 100%;
}

.btn:nth-child(2) {
  border-left: 1px solid #EFEFF4;
}
</style>
